import React from 'react'
import appicon from '../../Images/GIF/androidApp.gif'
import websiteIcon from '../../Images/GIF/websiteanimated.gif'
import softwareIcon from '../../Images/GIF/software.gif'
import CallingIcon from '../../Images/GIF/calling.gif'
import SoftwareDevelopementIcon from '../../Images/GIF/softwaredevelopmentheading.gif'
import websiteSoftwaresection from '../../Images/GIF/websitesoftwaresection.gif'
import appdevelopment from '../../Images/GIF/appdevelopment.gif'

export default function Softwaresection() {
  return (
    <>
      <section className='software-section' style={{ height: 'justify', backgroundColor: 'white', color: 'black', marginTop: 5 + 'vh' }}>

        <div className="container text-center">
          
            <img src={SoftwareDevelopementIcon} alt="" style={{width:'auto',height:30+'vh', marginBottom: 5 + 'vh',marginTop:10+'vh'}}/>
            
            
            <div className='conatiner-fluid' style={{backgroundColor:'grey',height:1+'px',width:100+'%',marginBottom:10+'vh'}}></div>

          
          <div className="container ">

            {/* ---------------------------------------- Card 1 Website Developement --------------------------------------------------*/}
            <div className="card mb-2 camerasection-card" style={{ backgroundColor: 'white', color: 'black', border: 'none' }} >
              <div className="row g-0">
                <div className="col-md-4">
                  <img src={websiteSoftwaresection} className="soft-sec img-fluid " style={{ borderRadius: 2 + 'vh' }} alt="..." />
                </div>

                <div className="col-md-8" style={{ padding: 2 + "vh" }}>
                  <div className="card-body">
                    <h1 className="card-title">Website Developement<img src={websiteIcon} className='websec-sm-web-icon' alt=""/></h1>
                    <p className="card-text"><h6 style={{ padding: 1 + 'px' }}><br />Give your imagination we will convert it into the Reality.<b /> </h6><br /> <b>Contact : Devanshu Sharma</b> </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://wa.me/+917073411116">
                          <img src={CallingIcon} alt="" className='location-gif' data-bs-toggle="tooltip" data-bs-title="Another one here too" href="#" />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ height: 30 + 'px', borderWidth: 2 + 'px', color: 'black', borderColor: 'black' ,marginBottom:8+'vh'}}></hr>

            {/* ---------------------------------------- Card 2 App Developement --------------------------------------------------*/}
            <div className="card mb-2 camerasection-card" style={{ backgroundColor: 'white', color: 'black', border: 'none' }} >
              <div className="row g-0">
                <div className="col-md-4">
                  <img src={appdevelopment} className="soft-sec img-fluid " style={{  borderRadius: 2 + 'vh' }} alt="..." />
                </div>

                <div className="col-md-8" style={{ padding: 2 + "vh" }}>
                  <div className="card-body">
                    <h1 className="card-title">App Developement <img src={appicon} className='app-ico-sm' alt="" /></h1>
                    <p className="card-text"><h6 style={{ padding: 1 + 'px' }}><br />A realtime application according to your needs.<b /> </h6><br /> <b>Contact : Devanshu Sharma</b> </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://wa.me/+917073411116">
                          <img src={CallingIcon} alt="" className='location-gif' data-bs-toggle="tooltip" data-bs-title="Another one here too" href="#" />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ height: 30 + 'px', borderWidth: 3 + 'px', color: 'black', borderColor: 'black' ,marginBottom:8+'vh'}}></hr>
            {/* ---------------------------------------- Card 3 App Developement --------------------------------------------------*/}

            <div className="card mb-2 camerasection-card" style={{ backgroundColor: 'white', color: 'black', border: 'none' }} >
              <div className="row g-0">
                <div className="col-md-4">
                <img src={softwareIcon} alt="" className="soft-sec img-fluid " style={{  borderRadius: 2 + 'vh' }} />
                </div>

                <div className="col-md-8" style={{ padding: 2 + "vh" , marginBottom:10+'vh' }}>
                  <div className="card-body">
                    <h1 className="card-title">Software Developement</h1>
                    <p className="card-text"><h6 style={{ padding: 1 + 'px' }}><br />The Software's which are likely used by D-Mart , Retail-Stores and more.<b /> </h6><br /> <b>Contact : Devanshu Sharma</b> </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://wa.me/+917073411116">
                          <img src={CallingIcon} alt="" className='location-gif' data-bs-toggle="tooltip" data-bs-title="Another one here too" href="#" />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            



          </div>
        </div>

      </section>
    </>
  )
}
